export default {"src":"/_next/static/media/arrow-right.6a686574.svg","height":10,"width":7,"blurWidth":0,"blurHeight":0};